import classNames from 'classnames'

import { CheckboxBase, ICheckboxCommonProps } from 'core-components/library/checkbox/CheckboxBase'

import styles from './Switch.module.scss'

export interface ISwitchProps extends ICheckboxCommonProps {
  /**
   * A Class name for component root node
   */
  className?: string
  /**
   * Text to the left of the marker
   */
  startLabel?: string
}

export const Switch = ({
  className,
  label,
  startLabel,
  checked,
  onChange,
  margin,
  padding,
  size = 'md',
  inline,
  disabled,
  wrapper,
}: ISwitchProps) => {
  return (
    <CheckboxBase
      testid={'switchRoot'}
      testidInput={'switchInput'}
      classes={{
        root: className || '',
        inner: styles.inner,
        control: styles.control,
        icon: classNames(styles.icon, wrapper && styles[`icon--${wrapper}`]),
        iconChecked: styles['icon--checked'],
        iconIndeterminate: styles['icon--indeterminate'],
        iconDisabled: styles['icon--disabled'],
        label: styles.label,
      }}
      label={label}
      startLabel={startLabel}
      checked={checked}
      onChange={onChange}
      margin={margin}
      padding={padding}
      size={size}
      inline={inline}
      disabled={disabled}
      wrapper={wrapper}
    />
  )
}
